export type WidgetIntegrationSubTabs = 'WIDGET' | 'AI_CHAT'
export const WidgetIntegrationSubTabMap: Record<WidgetIntegrationSubTabs, string> = {
  WIDGET: 'WIDGET',
  AI_CHAT: 'AI_CHAT',
}
